/**
 * vendor
 */
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

/**
 * Shared
 */
import PrivateRoute from 'app/PrivateRoute';
import Spinner      from '@shared/components/base/Spinner';
import ROUTES       from '@shared/lib/constants/routes';
import { openLoginModal } from 'mfe/auth-bridge';

/**
 * Features
 */
const PlayerTicketDetail = lazy(() => import('@features/tickets/pages/view/TicketDetail'));

/**
 * shop
 */
const ShopTickets = lazy(() => import('@features/shop-tickets/pages/list/Page'));

/**
 * Shop App routes
 *
 * @return {DOM}
 */
function AppRoutes() {
  function LoginRedirect() {
    React.useEffect(() => {
      openLoginModal();
    }, []);
    return <Navigate to={ROUTES.DEFAULT} replace />;
  }

  return (
    <Suspense fallback={<Spinner/>}>
      <Routes>
        {/*
          TODO:
            * Make a custom private route for shop that checks ACL role
            for shop then deny/redirect entry if role is not shop
        */}

        <Route
          path={ROUTES.SHOP.TICKET.LIST}
          element={<PrivateRoute component={ShopTickets} />}
        />

        <Route
          path={ROUTES.SHOP.TICKET.DETAIL}
          element={<PrivateRoute component={PlayerTicketDetail} />}
        />

        <Route path="*" element={<LoginRedirect />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;

